import React from 'react';
import AUX from '../../../hoc/Aux_';
import { Link } from 'react-router-dom';

const AllReports = () => {
  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex align-items-center mb-2 ">
          <h5 className="text-muted col-4">All Reports</h5>
        </div>
        <div className="container-fluid">
          <div className="d-flex " style={{ gap: '20px', flexWrap: 'wrap' }}>
            <div className="typeList-item typeList-item-1">
              <div className="d-flex justify-content-between align-items-center">
                <span>Tracked Hours</span>
                <Link to="/tracked-hours">
                  <button className="reports_btn">View More</button>
                </Link>
              </div>
              <div className="d-flex justify-content-end typeList-item--content">
                <img src="/assets/images/download.png" alt="no" />
              </div>
            </div>
            <div className="typeList-item typeList-item-2">
              <div className="d-flex justify-content-between align-items-center">
                <span>Timeline</span>
                <Link to="/timeline">
                  <button className="reports_btn">View More</button>
                </Link>
              </div>
              <div className="d-flex justify-content-end typeList-item--content">
                <img src="/assets/images/timeline.png" alt="no" />
              </div>
            </div>
            <div className="typeList-item typeList-item-3">
              <div className="d-flex justify-content-between align-items-center">
                <span>Attendance</span>
                <Link to="/attendance">
                  <button className="reports_btn">View More</button>
                </Link>
              </div>
              <div className="d-flex justify-content-end typeList-item--content">
                <img src="/assets/images/attendance.png" alt="no" />
              </div>
            </div>
            <div className="typeList-item typeList-item-4">
              <div className="d-flex justify-content-between align-items-center">
                <span>Activity Level</span>
                <Link to="/activity-level">
                  {' '}
                  <button className="reports_btn">View More</button>
                </Link>
              </div>
              <div className="d-flex justify-content-end typeList-item--content">
                <img src="/assets/images/activity-level.png" alt="no" />
              </div>
            </div>
            <div className="typeList-item typeList-item-2">
              <div className="d-flex justify-content-between align-items-center">
                <span>Statistics</span>
                <Link to="/statistics">
                  {' '}
                  <button className="reports_btn">View More</button>
                </Link>
              </div>
              <div className="d-flex justify-content-end typeList-item--content">
                <img src="/assets/images/statistics.png" alt="no" />
              </div>
            </div>
            <div className="typeList-item typeList-item-6">
              <div className="d-flex justify-content-between align-items-center">
                <span>Activity Description</span>
                <Link to="/activity-description">
                  {' '}
                  <button className="reports_btn">View More</button>
                </Link>
              </div>
              <div className="d-flex justify-content-end typeList-item--content">
                <img src="/assets/images/activity-description.png" alt="no" />
              </div>
            </div>
            <div className="typeList-item typeList-item-7">
              <div className="d-flex justify-content-between align-items-center">
                <span>Apps and Websites Usage</span>
                <Link to="/apps-and-website">
                  <button className="reports_btn">View More</button>
                </Link>
              </div>
              <div className="d-flex justify-content-end typeList-item--content">
                <img src="/assets/images/apps-website-usage.png" alt="no" />
              </div>
            </div>
            <div className="typeList-item typeList-item-8">
              <div className="d-flex justify-content-between align-items-center">
                <span>Tasks</span>
                <Link to="/tasks">
                  <button className="reports_btn">View More</button>
                </Link>
              </div>
              <div className="d-flex justify-content-end typeList-item--content">
                <img src="/assets/images/tasks.png" alt="no" />
              </div>
            </div>
            <div className="typeList-item typeList-item-14">
              <div className="d-flex justify-content-between align-items-center">
                <span>Finance</span>
                <Link to="finance-reports">
                  {' '}
                  <button className="reports_btn">View More</button>
                </Link>
              </div>
              <div className="d-flex justify-content-end typeList-item--content">
                <img src="/assets/images/finance.png" alt="no" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default AllReports;
